module.exports = __webpack_public_path__ + "static/media/complex.db481ee9.PNG";